import { styled } from '@mui/material/styles';
import { OutlinedInput } from '@mui/material';

// Toolbar search field.
//
// This used to force `border-width: 1px !important` and a grey
// `border-color: … !important` onto the fieldset. Both were redundant — the
// theme's MuiOutlinedInput override already sets that colour — and between them
// they beat MUI's `.Mui-focused` rule, so the field had no visible focus state at
// all. Removed, which restores the focus ring.
//
// Its width is set by the FormControl around it in GridListToolbar.
export const StyledSearch = styled(OutlinedInput)({
    width: '100%'
});
